module.exports = __webpack_public_path__ + "img/construction.fec1d0f5.png";